export const site = {
  empresa: 'ARCOPORACION',
  proyecto: 'Hacienda El Rodeo',
  ubicacion: 'Santa Catarina Mita, Jutiapa, Guatemala',
  telefono: '+502 5555 1234',
  whatsapp: '+502 5555 1234',
  email: 'ventas@arcoporacion.com',
  direccion: 'Km 148 Carretera a Santa Catarina Mita, Jutiapa, Guatemala',
  slogan: 'Invierte en lo que nunca pierde valor.',
}

export const navLinks = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'El Proyecto', href: '#proyecto' },
  { label: 'Amenidades', href: '#amenidades' },
  { label: 'Lotes', href: '#lotes' },
  { label: 'Financiamiento', href: '#financiamiento' },
  { label: 'Contacto', href: '#contacto' },
]

export const stats = [
  { value: 12, suffix: '', label: 'Lotes disponibles' },
  { value: 500, suffix: '+', label: 'Familias invirtiendo' },
  { value: 48, suffix: '', label: 'Hectáreas' },
  { value: 15, suffix: '', label: 'Años de experiencia' },
]

export const benefits = [
  { icon: 'trees', title: 'Sin banco', detail: 'Financiamiento directo' },
  { icon: 'file', title: 'Escrituración incluida', detail: 'Papelería al día' },
  { icon: 'coins', title: 'Enganche desde Q10,000', detail: 'Plazos flexibles' },
  { icon: 'home', title: 'Uso inmediato', detail: 'Construye desde el día uno' },
]

export const projectFeatures = [
  'Terrenos con vocación residencial y de descanso, listos para construir',
  'Plusvalía respaldada por el crecimiento comercial de Santa Catarina Mita',
  'A 15 minutos del casco urbano y sobre carretera asfaltada',
  'Escritura pública individual a nombre del comprador',
  'Servicios instalados: agua potable, energía eléctrica y drenajes',
  'Contrato de compraventa con cuotas fijas, sin intereses ocultos',
]

export const amenities = [
  { icon: 'road', label: 'Calles pavimentadas' },
  { icon: 'droplet', label: 'Agua potable' },
  { icon: 'zap', label: 'Luz eléctrica' },
  { icon: 'shield', label: 'Seguridad privada' },
  { icon: 'leaf', label: 'Área verde' },
  { icon: 'scroll', label: 'Escritura propia' },
  { icon: 'navigation', label: 'Fácil acceso' },
  { icon: 'wifi', label: 'Wi-Fi comunitario' },
  { icon: 'pipe', label: 'Drenajes' },
]

export const gallery = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/gTT57rQw6h1fKvn8ZhLYFv/img8.jpg',
    title: 'Lotes delimitados',
    caption: 'Etapa 1 — lista para construir',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2tYNsCWJMMs3ZipM1FshkH/img1.jpg',
    title: 'Acceso asfaltado',
    caption: 'Sobre carretera principal',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gnjEq8Xr7UyBTiWw2zdiW7/img2.jpg',
    title: 'Atardecer en El Rodeo',
    caption: 'Tanque de agua y calles trazadas',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ep8XXHff6zdcjnA84VAcVd/img6.jpg',
    title: 'Vista panorámica',
    caption: 'El valle de Santa Catarina Mita',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gt7qSzhqfeEkX57QttMgfc/img5.jpg',
    title: 'Entorno del proyecto',
    caption: 'Montaña y cielo abierto',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9qW27chVn81nimeFYvre3y/img9.jpg',
    title: 'Calles internas',
    caption: 'Acceso directo a cada lote',
  },
]

export const testimonials = [
  {
    nombre: 'María Fernanda López',
    ciudad: 'Jutiapa',
    estrellas: 5,
    comentario:
      'Compré mi lote sin necesidad de banco ni historial crediticio. La cuota es fija y en 8 meses ya tenía mi escritura en la mano. Nunca sentí presión, solo acompañamiento.',
  },
  {
    nombre: 'Carlos Estuardo Ramírez',
    ciudad: 'Ciudad de Guatemala',
    estrellas: 5,
    comentario:
      'Buscaba una inversión segura fuera de la capital. Hacienda El Rodeo ya subió de precio desde que aparté mi lote y puedo construir cuando quiera.',
  },
  {
    nombre: 'Ana Lucía Morales',
    ciudad: 'Asunción Mita',
    estrellas: 5,
    comentario:
      'Todo el proceso fue transparente: me mostraron el plano, medidas reales y el contrato antes de pagar el enganche. Aprobación el mismo día.',
  },
  {
    nombre: 'Byron Alexander Pérez',
    ciudad: 'Chiquimula',
    estrellas: 5,
    comentario:
      'Ya somos vecinos de varias familias conocidas. Calles pavimentadas, agua y luz desde el primer día. Mi papá compró el lote de al lado.',
  },
]

export const comparison = [
  { criterio: 'Trámites y papeleo', banco: 'Expediente completo', arco: 'Solo DPI y enganche' },
  { criterio: 'Historial crediticio', banco: 'Obligatorio y sin moras', arco: 'No se requiere' },
  { criterio: 'Tiempo de aprobación', banco: '3 a 6 semanas', arco: 'Menos de 24 horas' },
  { criterio: 'Enganche mínimo', banco: '30% a 40%', arco: 'Desde Q10,000' },
  { criterio: 'Comisiones y seguros', banco: 'Gastos administrativos', arco: 'Sin cargos ocultos' },
  { criterio: 'Escrituración', banco: 'Por cuenta del cliente', arco: 'Incluida' },
]

export const processSteps = [
  { titulo: 'Elige tu lote', detalle: 'Recorre el plano o visita el proyecto con un asesor.' },
  { titulo: 'Firma contrato', detalle: 'Contrato de compraventa con cuota fija y plazo definido.' },
  { titulo: 'Paga tu enganche', detalle: 'Desde Q10,000, en efectivo o transferencia.' },
  { titulo: '¡Es tuyo!', detalle: 'Recibes tu lote y puedes empezar a construir de inmediato.' },
]

export const referralSources = [
  'Facebook o Instagram',
  'TikTok',
  'Recomendación de un familiar o amigo',
  'Valla o rótulo en carretera',
  'Búsqueda en Google',
  'Otro medio',
]
